import React from "react";
import { connect } from "react-redux";
import { Row, Container } from "ctia-react-bootstrap-v4";
import AscContainer from "components/ProgramSelector/ServiceCenter/AscContainer";

const HomeASC = ({ app, user }) => {
  if (!user.role) return null;

  const fluid = app.sm ? "fluid" : "";

  const rowSettings = {
    xl: 3,
    lg: 3,
    md: 3,
    sm: 12
  };

  return (
    <Container {...fluid}>
      <Row {...rowSettings} style={{ marginTop: 0 }}>
        <div className="home-description">
          <h1>Authorized Service Center Resources</h1>
          <AscContainer />
        </div>
      </Row>
    </Container>
  );
};

function mapStateToProps({ app, user }) {
  return { app, user };
}

export default connect(mapStateToProps)(HomeASC);
